import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ToastrService } from 'core/toastr.service';
import { AddressDetails, UpdateAddressGeolocationInput, UpdateGeocodeGQL } from 'generated/graphql';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-update-geocode',
  templateUrl: './update-geocode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateGeocodeComponent implements OnInit {
  @Input() address: {id: string; latitude: any; longitude: any; geocodeBad: boolean};
  @Output() saved = new EventEmitter<AddressDetails.Fragment>();
  form: UntypedFormGroup;

  /**
   *
   */
  constructor(
    private _updateGeocodegQL: UpdateGeocodeGQL,
    private _toastrService: ToastrService
  ) { }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      latitude: new UntypedFormControl(this.address.latitude),
      longitude: new UntypedFormControl(this.address.longitude),
      geocodeBad: new UntypedFormControl(this.address.geocodeBad)
    });
  }

  onUseMyLocationClick() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((res) => {
        if (res && res.coords) {
          this.form.patchValue({
            latitude: res.coords.latitude,
            longitude: res.coords.longitude
          });
        }
      });
    }
  }

  onSaveClick() {
    const formValue = this.form.value;
    const input: UpdateAddressGeolocationInput = {
      addressId: this.address.id,
      latitude: parseFloat(formValue.latitude),
      longitude: parseFloat(formValue.longitude),
      source: 'user_added',
      accuracyType: 'rooftop',
      accuracy: 1.0,
      geocodeBad: formValue.geocodeBad === true ? true : false
    };

    this._updateGeocodegQL.mutate({ input })
      .pipe(
        map(res => res.data)
      )
      .subscribe(result => {
        this._toastrService.success('Geocode updated.');
        this.saved.emit(result.updateAddressGeolocation.address);
      });
  }
}
